import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, ReactReduxContext } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { Router } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import ScrollMemory from 'react-router-scroll-memory';
import history from './redux/history';
// import { createBrowserHistory } from 'history';
import store from './redux/store';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import mixpanel from 'mixpanel-browser';
import App from './containers/AppContainer';
import { Userpilot } from 'userpilot';

const persistor = persistStore(store);
const MOUNT_NODE = document.getElementById('root');
let sentryURL = '';

if (
  process.env.REACT_APP_API_URL == 'http://localhost:8000' ||
  process.env.REACT_APP_API_URL == 'https://app-dev.silentpush.com' ||
  process.env.REACT_APP_API_URL == 'https://explore-dev.silentpush.com'
) {
  mixpanel.init('9cf20c3ed30225eb2eae6334af0eafad', {
    debug: true,
    ignore_dnt: true,
  });
  sentryURL = 'http://776fd5bd045b4439bcc0037d6b2f31dd@sentry.silentpush.com/3';
} else if (
  process.env.REACT_APP_API_URL == 'https://app-staging.silentpush.com' ||
  process.env.REACT_APP_API_URL == 'https://app.silentpush.com' ||
  process.env.REACT_APP_API_URL == 'https://explore.silentpush.com' ||
  process.env.REACT_APP_API_URL == 'https://api.silentpush.com'
) {
  mixpanel.init('b8e8f353ee57c63b49738b57c46a20bd', { debug: false });
  sentryURL =
    'https://776fd5bd045b4439bcc0037d6b2f31dd@sentry.silentpush.com/3';
} else {
  mixpanel.init('9cf20c3ed30225eb2eae6334af0eafad', {
    debug: true,
    ignore_dnt: true,
  });
  sentryURL = 'http://776fd5bd045b4439bcc0037d6b2f31dd@sentry.silentpush.com/3';
}

// sentry-trace header can't be added in local environment (backend CORS policy)
if (process.env.REACT_APP_API_URL !== 'http://localhost:8000') {
  Sentry.init({
    dsn: sentryURL,

    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

Userpilot.initialize('NX-f76e366d');

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Router history={history} context={ReactReduxContext}>
        {/* <ConnectedRouter history={history} context={ReactReduxContext}> */}
        <ScrollMemory />
        <App history={history} context={ReactReduxContext} />
        {/* </ConnectedRouter> */}
      </Router>
    </PersistGate>
  </Provider>,
  MOUNT_NODE,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
